import type { FindGamesQuery, GameListItemFragment } from "../graphql/types"
import { EsrbRating, GameMode } from "../graphql/types"
import type { OrderRaw } from "../components/order"
import type { PageFragment } from "../PageFragment"

export const GAME_GENRES_STORAGE_KEY = "nfans.games.genres"
export const GAME_GAME_SERIES_STORAGE_KEY = "nfans.games.gameSeries"
export const GAME_GAME_CONSOLES_STORAGE_KEY = "nfans.games.gameConsoles"
export const GAME_COMPANIES_STORAGE_KEY = "nfans.games.companies"
export const GAME_GAME_MODES_STORAGE_KEY = "nfans.games.gameModes"
export const GAME_USK_STORAGE_KEY = "nfans.games.usk"
export const GAME_PEGI_STORAGE_KEY = "nfans.games.pegi"
export const GAME_ESRB_STORAGE_KEY = "nfans.games.esrb"
export const GAME_RELEASE_YEAR_STORAGE_KEY = "nfans.games.releaseYear"
export const GAME_RELEASE_MONTH_STORAGE_KEY = "nfans.games.releaseMonth"
export const GAME_ONLY_UPCOMING_STORAGE_KEY = "nfans.games.onlyUpcoming"
export const GAME_ORDER_STORAGE_KEY = "nfans.games.order"

export const GAME_ORDER_PROPERTIES: Array<OrderRaw> = [
  { label: "Erscheinung",         properties: [{ property: "initialReleaseDate", defaultDirection: "desc" }] },
  { label: "Name",                properties: [{ property: "name",               defaultDirection: "asc"  }] },
  { label: "Release Deutschland", properties: [{ property: "releaseDateGermany", defaultDirection: "desc" }] },
  { label: "Akronym",             properties: [{ property: "acronym",            defaultDirection: "asc"  }] },
  { label: "Erstellt",            properties: [{ property: "createdDate",        defaultDirection: "desc" }] },
  { label: "Zuletzt geändert",    properties: [{ property: "lastModifiedDate",   defaultDirection: "desc" }] },
]

export function extractFindGamesPage(result: FindGamesQuery): PageFragment<GameListItemFragment> {
  return result.findGames
}

export function extractFindGamesItems(result: FindGamesQuery): GameListItemFragment[] {
  return result.findGames?.content ?? []
}

export const GAME_MODE_LABELS: Record<GameMode, string> = {
  [GameMode.SINGLEPLAYER]:        "Singleplayer",
  [GameMode.LOCAL_CO_OP]:         "Local Co-Op",
  [GameMode.LOCAL_MULTIPLAYER]:   "Local Multiplayer",
  [GameMode.ONLINE_CO_OP]:        "Online Co-Op",
  [GameMode.ONLINE_MULTIPLAYER]:  "Online Multiplayer",
}

export const ESRB_LABELS: Record<EsrbRating, string> = {
  [EsrbRating.EVERYONE]:                          "Everyone",
  [EsrbRating.EVERYONE_TEN_PLUS]:                 "Everyone 10+",
  [EsrbRating.TEEN]:                              "Teen",
  [EsrbRating.MATURE_PLUS]:                       "Mature 17+",
  [EsrbRating.ADULTS_ONLY]:                       "Adults Only 18+",
  [EsrbRating.RATING_PENDING]:                    "Rating Pending",
  [EsrbRating.RATING_PENDING_LIKELY_MATURE_PLUS]: "RP — Likely Mature 17+",
}
